export const vrnEntered = {
    event: "vrn_entered",
    eventCategory: "Challan_homepage",
    eventAction: "VRN_entered"
};

export const vrnChanged = {
    event: "vrn_changed",
    eventCategory: "Challan_view",
    eventAction: "VRN_changed"
};
